(() => {
  // ── Scroll Reveal (IntersectionObserver) ────────────────────────────────────
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-visible');
      io.unobserve(e.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  function observe(el, delay) {
    if (!el) return;
    if (el.closest('.aflora-home-hero')) return; // hero uses CSS animations
    if (el.classList.contains('aflora-reveal')) return;
    el.classList.add('aflora-reveal');
    if (delay > 0) el.dataset.delay = String(Math.min(delay, 5));
    io.observe(el);
  }

  function initReveal() {
    // Section text hierarchy — eyebrow → heading → body → CTA (stagger 0–3)
    document.querySelectorAll('.aflora-home-section:not(.aflora-home-hero)').forEach(function (section) {
      [
        '.aflora-home-section__eyebrow',
        '.aflora-home-section__heading',
        '.aflora-home-section__text',
        '.aflora-home-btn',
      ].forEach(function (sel, i) {
        section.querySelectorAll(sel).forEach(function (el) { observe(el, i); });
      });
    });

    // Grid children: stagger by child index
    ['.aflora-home-products__grid', '.aflora-home-stats__grid'].forEach(function (gridSel) {
      document.querySelectorAll(gridSel).forEach(function (grid) {
        Array.from(grid.children).forEach(function (child, i) { observe(child, i); });
      });
    });

    // Line cards
    document.querySelectorAll('.aflora-home-line-card').forEach(function (el, i) {
      observe(el, i);
    });

    // Bundle copy children + bundle product images
    document.querySelectorAll('.aflora-home-bundle__copy > *').forEach(function (el, i) {
      observe(el, i);
    });
    document.querySelectorAll('.aflora-home-bundle__product').forEach(function (el, i) {
      observe(el, i);
    });

    // Other components
    [
      '.aflora-home-spotlight__panel',
      '.aflora-home-spotlight__media',
      '.aflora-home-philosophy__item',
      '.aflora-home-reviews__card',
      '.aflora-home-newsletter__inner',
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, i) {
        observe(el, Math.min(i, 4));
      });
    });
  }

  // ── Stats Counter (count-up on reveal) ──────────────────────────────────────
  function fmtNum(n, isFloat) {
    if (isFloat) return n.toFixed(1);
    return n >= 1000 ? n.toLocaleString('en-US') : String(Math.round(n));
  }

  function countUp(el, target, isFloat, suffix, duration) {
    var t0 = performance.now();
    function tick(now) {
      var p    = Math.min((now - t0) / duration, 1);
      var ease = 1 - Math.pow(1 - p, 3);   // ease-out-cubic
      el.textContent = fmtNum(ease * target, isFloat) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initCounters() {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el  = e.target;
        var num = parseFloat(el.dataset.num);
        if (!isNaN(num)) {
          countUp(el, num, el.dataset.isFloat === '1', el.dataset.suffix, 1800);
        }
        cio.unobserve(el);
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('.aflora-home-stats__value').forEach(function (el) {
      var text = el.textContent.trim();
      var m    = text.match(/([\d,]+\.?\d*)/);
      if (!m) return;
      var raw = m[1].replace(/,/g, '');
      var num = parseFloat(raw);
      if (isNaN(num)) return;
      el.dataset.num     = raw;
      el.dataset.suffix  = text.replace(m[0], '');
      el.dataset.isFloat = raw.includes('.') ? '1' : '0';
      cio.observe(el);
    });
  }

  // ── Hero Parallax ──────────────────────────────────────────────────────────
  // Image moves up at 20% of scroll speed → depth/parallax feel
  function initParallax() {
    var media = document.querySelector('.aflora-home-hero__media');
    var hero  = document.querySelector('.aflora-home-hero');
    if (!media || !hero) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y < hero.offsetHeight * 1.5) {
          media.style.transform = 'translateY(' + (-(y * 0.20)) + 'px)';
        }
        ticking = false;
      });
      ticking = true;
    }, { passive: true });
  }

  function init() {
    initReveal();
    initCounters();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init on Shopify section editor changes
  document.addEventListener('shopify:section:load', function () { init(); });
})();
